import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const TimeSeriesChart = ({ data }) => {
  const options = {
    chart: {
      type: "spline",
      height: 50, // Small chart height
      margin: [10, 0, 10, 0], // Compact margins
    },
    title: {
      text: null, // No title
    },
    xAxis: {
      type: "datetime",
      labels: {
        enabled: false, // Disable x-axis labels
      },
      lineWidth: 0, // Remove x-axis line
      tickWidth: 0, // Remove ticks
    },
    yAxis: {
      title: {
        text: null, // No y-axis title
      },
      labels: {
        enabled: false, // Disable y-axis labels
      },
      gridLineWidth: 0, // Remove gridlines
    },
    tooltip: {
      xDateFormat: "%H:%M", // Format tooltip time
      shared: true,
    },
    series: [
      {
        name: "Value",
        data: data, // Time series data
        color: "#007bff",
        marker: {
          enabled: false, // Disable markers
        },
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false, // Disable legend
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default TimeSeriesChart;
